import { ReactNode } from 'react';

interface SidebarWrapperProps {
  isMobileMenuOpen: boolean;
  isSidebarCollapsed: boolean;
  children: ReactNode;
}

export function SidebarWrapper({
  isMobileMenuOpen,
  isSidebarCollapsed,
  children,
}: SidebarWrapperProps) {
  return (
    <div
      className={`
        fixed inset-y-0 left-0 transform
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        ${isSidebarCollapsed ? 'lg:-translate-x-full' : 'lg:translate-x-0'}
        w-[200px]
        transition-transform duration-300 ease-in-out
        bg-theme-light-sidebar dark:bg-theme-dark-sidebar z-50 flex flex-col
      `}
    >
      {/* Spacer for content below fixed logo */}
      <div className="h-24"></div>

      {children}
    </div>
  );
}
